import { type ReactNode } from "react"

/** The accent-mesh panel every job graphic sits on. */
export function MeshFrame({ children }: { children: ReactNode }) {
  return (
    <div className="border-lp-border relative isolate overflow-hidden rounded-[24px] border p-5 sm:p-8">
      <div className="lp-mesh absolute inset-0 z-0" />
      <div className="lp-mesh-grain absolute inset-0 z-1" />
      {/* min-height keeps the three job frames the same size regardless of
          how tall their content is; shorter graphics centre in the well. The
          frosted halo ring matches the hero window's treatment. */}
      <div className="relative z-2 flex min-h-[400px] flex-col justify-center">
        <div className="rounded-3xl bg-white/20 p-2 backdrop-blur-md">
          {children}
        </div>
      </div>
    </div>
  )
}
